const { getAll } = require( "@/utilities/querySelector" );

document.addEventListener( 'DOMContentLoaded', function() {

    const groups = getAll( '[data-font-alternator]' );
    groups.forEach( group => {
        const headingItems = getAll( '[data-font-alternate]', group );

        if ( headingItems.length === 0 ) return group.remove();

        headingItems.forEach( item => item.innerHTML = separate( item.textContent ) );

        group.setAttribute( 'data-font-alternator', 'init' );

        loop( headingItems );
    } );

    async function loop( items ) {
        const iterator = getLoopingIterator( items );

        let animateText = iterator.next();

        while ( true ) {
            await sleep( 2000 );
            await dissipate( animateText );
            animateText = iterator.next();
            await apparate( animateText );
        }
    }

    /**
     * Takes a word and animates the letters randomly in a float above and out effect with js animations,
     * presume the letters are all individually spanned
     *
     * @param {HTMLElement} word
     *
     * @returns {Promise<Animation>}
     */
    function dissipate( word ) {
        const letters = getAll( 'span', word );
        let anim;

        letters.forEach( ( letter, index ) => {
            const delay = 25 * index;
            const duration = 300 + ( Math.random() * 400 );
            const endPosition = [( Math.random() - 0.5 ) * 75, ( Math.random() - 0.5 ) * 50 - 75];

            anim = letter.animate( {
                transform: [
                    'translate(0, 0)',
                    `translate(${endPosition[0]}px, ${endPosition[1]}px)`
                ],
                opacity: [1, 0]
            }, {
                duration,
                easing: 'cubic-bezier(.22,1.21,.76,.7)',
                delay,
                fill: 'both',
            } );
        } );

        return anim.finished;
    }


    /**
     * Somewhat a reverse of dissipate, animate the letters fading and rising into place
     *
     * @param {HTMLElement} word
     *
     * @return void
     */
    function apparate( word ) {
        const letters = getAll( 'span', word );
        let anim;

        letters.forEach( ( letter, index ) => {
            const duration = 300 + ( Math.random() * 400 );
            const delay = 50 * index;
            const startPosition = [( Math.random() - 0.5 ) * 25, ( Math.random() - 0.5 ) * 15 + 25];

            anim = letter.animate( {
                transform: [
                    `translate(${startPosition[0]}%, ${startPosition[1]}%)`,
                    'translate(0, 0)'
                ],
                opacity: [0, 1]
            }, {
                duration,
                easing: 'ease-in',
                delay,
                fill: 'both',
            } );
        } );

        return anim.finished;
    }

    /**
     * @param {number} duration
     * @return {Promise<void>}
     */
    function sleep( duration ) {
        return new Promise( resolve => {
            setTimeout( resolve, duration );
        } );
    }

    /**
     * @param {Array<HTMLElement>|NodeListOf<HTMLElement>} arrayLike
     *
     * @return {any}
     */
    function getLoopingIterator( arrayLike ) {
        return {
            next: function() {
                const item = arrayLike[this.current];
                this.current = this.current === ( this.max - 1 ) ? 0 : this.current + 1;
                return item;
            },
            prev: function() {
                const item = arrayLike[this.current];
                this.current = this.current === 0 ? ( this.max - 1 ) : this.current - 1;
                return item;
            },
            current: 0,
            max: arrayLike.length
        };
    };

    function separate( word ) {
        return word.split( '' ).map( l => `<span>${l}</span>` ).join( '' );
    }
} );